import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=d8714180&scoped=true"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"
import style0 from "./deposit.vue?vue&type=style&index=0&id=d8714180&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8714180",
  null
  
)

export default component.exports